import React from 'react';
import {useTranslation} from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ExportConfirm({message, exportFunc, setOpenExport}) {

    const {t} = useTranslation();

    const handleOKClick = () => {
        exportFunc(true);
        setOpenExport(false);
    };

    const handleClose = () => {
        exportFunc(false);
        setOpenExport(false);
    };

    return (
        <Dialog open={true} onClose={handleClose}>
            <DialogTitle></DialogTitle>
            <DialogContent>
                <DialogContentText color="textPrimary">
                    {message}
                </DialogContentText>

                <Button
                    onClick={handleClose}
                    variant="outlined"
                    style={{
                        float: 'left',
                        backgroundColor: "#BBBBBB",
                        borderRadius: "2px",
                        color: "#fff",
                        width: "45%",
                        border: "none"
                    }}>
                    {t('CONTENT.MODAL.CANCEL')}
                </Button>
                <Button
                    onClick={handleOKClick}
                    variant="outlined"
                    style={{
                        float: 'right',
                        backgroundColor: "#46474E",
                        borderRadius: "2px",
                        color: "#fff",
                        width: "45%",
                        border: "none"
                    }}>
                    {t('CONTENT.MODAL.OK')}
                </Button>
            </DialogContent>
        </Dialog>
    );
}
